import lodashHas from "lodash/has";
import { httpGet, httpPost } from "@/services/api.service";
import { ENDPOINT_MY_INCIDENTS } from "@/common/constants/api";
import { MY_INCIDENTS_ICONS } from "@/common/constants/myIncidents";

export { _getMyIncidents as getMyIncidents };
export { _loadMapIcons as loadMapIcons };
export { _getCategories as getCategories };
export { _saveMyIncident as saveMyIncident };

const _getMyIncidents = async (params) => {
  try {
    const {
      page,
      itemsPerPage,
      sortBy,
      sortDirection,
      search,
      startDate,
      endDate,
    } = params.options;
    const url = new URL(ENDPOINT_MY_INCIDENTS);

    const sort = sortBy?.map(
      (item, index) => `${item}:${sortDirection[index]}`
    );

    if (!!page) {
      url.searchParams.append("page", page);
    }
    if (!!itemsPerPage) {
      url.searchParams.append("pageSize", itemsPerPage);
    }
    if (!!sortBy) {
      url.searchParams.append("sort", sort.join(","));
    }
    if (!!search) {
      url.searchParams.append("search", search);
    }
    if (!!startDate) {
      url.searchParams.append("startDate", startDate);
    }
    if (!!endDate) {
      url.searchParams.append("endDate", endDate);
    }

    const response = await httpGet({
      url: url.toString(),
    });
    const parsedResponse = JSON.parse(response);
    if (lodashHas(parsedResponse, "data.incidents")) {
      return parsedResponse.data;
    }
    return {
      incidents: undefined,
      metadata: {
        pageNumber: undefined,
      },
    };
  } catch (error) {
    console.error("Error retrieving my incidents: ", error);
    return false;
  }
};

const _loadIcon = (map, id, src) => {
  map.loadImage(src, (err, image) => {
    if (err) {
      console.error(err);
    } else {
      map.addImage(id, image);
    }
  });
};

const _loadMapIcons = (map) => {
  MY_INCIDENTS_ICONS.filter((icon) => !map.hasImage(icon.value)).forEach(
    (icon) => {
      _loadIcon(
        map,
        `${icon.value}`,
        require(`@/assets/images/icons/${icon.fileName}`)
      );
    }
  );
};

const _getCategories = () => {
  //TODO: Update this after or as part of AAAS-6314
  //This should come from Incident Profile
  return [
    "Travel",
    "Disasters",
    "Unrest",
    "Conflict",
    "Health",
    "Crime",
    "Terrorism",
    "Transportation",
    "Organized Crime",
  ];
};

const _saveMyIncident = async (incident) => {
  try {
    if (!incident.id) {
      await httpPost({
        url: ENDPOINT_MY_INCIDENTS,
        data: incident,
      });
      return true;
    } else {
      console.error("My Incident Put not currently supported");
      return false;
    }
  } catch (error) {
    console.error("Unable to save incident", error);
    return false;
  }
};
